import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Grid from 'screens/components/basic/Grid';
import Button from 'screens/components/basic/Button';
import {
    getCombos, getProductByBarcode, checkComboProductQuantity
} from 'actions/EntityActions';
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import { showError } from 'actions/CommonActions';

const customContentStyle = {
    width: '75%',
    maxWidth: 'none'
};

class POSCombos extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            comboDetailDialogOpen: false,
            selectedCombo: null
        }
    }

    componentDidMount() {
        if (this.props && this.props.getCombos) {
            this.props.getCombos({
                branchId: this.props.branchId,
                onlyActive: true
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.comboCheckTimeStamp && this.props.comboCheckTimeStamp != prevProps.comboCheckTimeStamp) {
            if (this.props.comboCheckSuccess) {
                this.props.voidItem(this.props.orderId, this.props.comboProductClicked.orderProductId, true);
            } else {
                this.props.showError(this.props.comboCheckError);
            }
        }
        if (this.props.comboProductClicked != null && this.props.posOrder && this.props.posOrder != prevProps.posOrder) {
            this.addToOrder(this.state.selectedCombo);
        }
    }

    checkDetails = (combo) => {
        console.log(combo);
        this.setState({
            comboDetailDialogOpen: true,
            selectedCombo: combo
        });
    }

    addCombo = (comboId) => {
        if (this.props.filterCombos.length > 0 && this.props.comboProductClicked != null) {
            this.props.checkComboProductQuantity(this.props.branchId, comboId, this.props.comboProductClicked.productId, this.props.comboProductClicked.quantityAddedBack)
            this.setState({ selectedCombo: comboId });
        } else {
            this.addToOrder(comboId)
        }
    }

    addToOrder = (id) => {
        let barCode = 'C' + (`00000000000${id}`).slice(-11);
        this.props.getProductByBarcode(barCode, this.props.branchId);
        this.props.onClose();
    }

    closeComboDetailDialog = () => {
        this.setState({ comboDetailDialogOpen: false });
    }

    render() {
        const { t } = this.props;
        const combos = this.props.combos;
        let selectedCombo = this.state.selectedCombo;

        return (
            <Grid>
                <div className="row m-0">
                    {
                        (this.props.combos === null) &&
                        <div className="alert alert-warning">
                            {t('pos.combos.comboNotFound')}
                        </div>
                    }
                </div>
                <div className="row m-0">
                    {
                        (combos !== undefined && combos !== null) &&
                        combos.map((combo, index) => {
                            let combonamestripped = combo.name.replace(/\s+/g, '')
                            if (this.props.checkComboInDateRange(combo) &&
                                (this.props.filterCombos.length == 0 || this.props.filterCombos.includes(combo.id))
                            )
                                return (
                                    <div key={index} className="item-online-order">
                                        <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4">
                                            <div>
                                                {combo.name}
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 btn-start" id={`${combonamestripped}ViewDetails`}>
                                            <Button
                                                name="finishButton"
                                                label={t('common.viewDetails')}
                                                className="pull-right btn-finish"
                                                primary={true}
                                                onTouchTap={() => this.checkDetails(combo)}
                                            />
                                        </div>
                                        <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 btn-start" id={`${combonamestripped}AddToOrder`}>
                                            <Button
                                                name="finishButton"
                                                label={t('pos.combos.addToOrder')}
                                                className="pull-right btn-load-create-order btnNewBrandPOS"
                                                primary={true}
                                                onTouchTap={() => this.addCombo(combo.id)}
                                            />
                                        </div>
                                    </div>
                                )
                        })
                    }
                </div>
                <DialogInput
                    title={<DialogHeaderWithClose text={t('pos.combos.comboDetail')} classicClass="posDialogClassic" handleClose={() => this.closeComboDetailDialog()} />}
                    modal={true}
                    open={this.state.comboDetailDialogOpen}
                    autoScrollBodyContent={true}
                    className="online-orders-line-dialog checkIn_list"
                    handleClose={() => this.closeComboDetailDialog()}
                    contentStyle={customContentStyle}
                >
                    {
                        selectedCombo ?
                            <div className='text-center purpleText'>
                                <h3>{t('common.name')}: {selectedCombo.name}</h3>
                                <h3>{t('common.price')}: ${selectedCombo.price}</h3>
                                ----------------------------------------------------------------
                                <h4>{t('pos.productListPage.products')}</h4>
                                {
                                    selectedCombo.products &&
                                    (
                                        <div>
                                            {
                                                selectedCombo.products.map((product, index) => {
                                                    return (
                                                        <h5 key={index}>
                                                            {
                                                                product &&
                                                                `${product.name || t('pos.combos.comboDetail')} × ${product.quantity}`
                                                            }
                                                        </h5>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                }
                            </div>
                            : ""
                    }
                    <div id="closeComboDetails">
                        <Button name="buttonCancel"
                            type="Button"
                            className="corner_X"
                            label=""
                            onTouchTap={() => this.closeComboDetailDialog()}
                        />
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}



function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        combos: state.entity.comboList || [],
        posOrder: state.entity.posOrder,
        comboCheckSuccess: state.form.ComboCheckSuccess,
        comboCheckTimeStamp: state.form.ComboCheckTimeStamp,
        comboCheckError: state.form.ComboCheckError
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getCombos: (model) => dispatch(getCombos(model)),
        getProductByBarcode: (barcode, branchId) => dispatch(getProductByBarcode(barcode, branchId)),
        checkComboProductQuantity: (branchId, comboId, comboProductClicked, quantityAddedBack) => dispatch(checkComboProductQuantity(branchId, comboId, comboProductClicked, quantityAddedBack)),
        showError: (message) => dispatch(showError(message)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSCombos))